var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70.378,
    height: 50.922,
    viewBox: "0 0 70.378 50.922",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M3195.7-22372.465s2.358,6.953,4.716,6.953,1.834-6.953,4.717-6.953,3.45,1.926,6.813,6.953,2.8,13.621,6.638,13.168,4.717-16.645,8.734-15,4.411,17.281,7.337,21.586,1.747-5.121,4.367-4.387,2.838,9.512,6.114,7.313,3.93-13.719,6.987-16.094,1.006,6.383,4.518,6.258c4.218-.129,6.535-34.121,7.059-38.586",
    transform: "translate(-3194.433 22392.365)",
    fill: "none",
    stroke: "#34b53a",
    strokeLinecap: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartIcon);
export default __webpack_public_path__ + "static/media/chart-icon.16e955e1f72d9b7d95b5f41f287818dd.svg";
export { ForwardRef as ReactComponent };